import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "antd";
import HomeContainer from "./pages/Home/container";
import AboutContainer from "./pages/About/container";
import BlogContainer from "./pages/Blog/Container";
import PostContainer from "./pages/Post/container";
import OurToolContainer from "./pages/OurTool/container";
import ContactContainer from "./pages/Contact/container";
import ServicesContainer from "./pages/Services/container";
import MethodologyContainer from "./pages/Methodology/container";
import Contact from "./pages/Contact";
import EvaluationContainer from "./pages/Evaluation/container";
import Signin from "./pages/SignIn/container";
import FrontPageContainer from "./pages/FrontPage/container";
import ForgotPassword from "./pages/ForgotPassword/container";
import BlogCollectionContainer from "./pages/Admin/BlogCollection/container";
import UserCollectionContainer from "./pages/Admin/UsersCollection/container";
import BlogDocumentContainer from "./pages/Admin/BlogDocument/container";
import ResultCollectionContainer from "./pages/Admin/ResultCollection/container";
import ResultDocumentContainer from "./pages/Admin/ResultDocument/container";
import ResultTaDocumentContainer from "./pages/Admin/ResultDocument/ResultTADocument/container";
import SurveyResultsHOCContainer from "./pages/SurveyResults/container";
import history from "./history";
import { Router, Route, Switch, Link } from "react-router-dom";
import { changeLanguage } from "./modules/preference/actions";
import {
  signInSuccess,
  getUserData,
  signedOut,
  getUser
} from "./modules/user/actions";
import "./App.css";
import Loader from "./components/Loader";

const PrivateRoute = ({
  component: Component,
  getUser,
  userRole,
  isAdmin,
  isAdminLoaded,
  uid,
  ...rest
}) => {
  if (uid === null) {
    return <Loader />;
  }
  getUser(uid);
  return (
    <Route
      {...rest}
      render={props =>
        // isAuthenticated === true
        !isAdminLoaded ? (
          <Loader />
        ) : userRole === "admin" ? (
          <Component {...props} />
        ) : (
          <div className="noAccessContainer">
            <div>
              <div>You don't have access</div>
              <div>
                <Link to="/">
                  <Button>Go back to website</Button>
                </Link>
              </div>
            </div>
          </div>
        )
      }
    />
  );
};

const TARoute = ({
  component: Component,
  getUser,
  userRole,
  isTest,
  isTestLoaded,
  uid,
  type,
  ...rest
}) => {

  if (uid === null) {
    return <Signin />;
  }
  getUser(uid);

  return (
    <Route
      {...rest}
      render={props =>
        // isAuthenticated === true
        !isTestLoaded ? (
          <Loader />
        ) : userRole === "ta" || userRole === "admin" ? (
          <Component {...props} type={type} />
        ) : (
          <div className="noAccessContainer">
            <div>
              <div>You don't have access</div>
              <div>
                <Link to="/">
                  <Button>Go back to website</Button>
                </Link>
              </div>
            </div>
          </div>
        )
      }
    />
  );
};

class App extends Component {
  componentDidMount() {
    const language = localStorage.getItem("language");
    if (language) {
      this.props.changeLanguage(language);
    }
    window.scrollTo(0, 0);
    const props = this.props;
    window.firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        props.getUserData(user);
      } else {
        props.signedOut();
        // No user is signed in.
        if (history.location.pathname.includes("admin")) {
          history.replace("/sign-in");
        } else if (history.location.pathname.includes("tatest")) {
        }
      }
    });
  }
  render() {
    return (
      <Router history={history}>
        <div className="App">
          <Switch>
            <Route exact path="/" component={HomeContainer} />
            <Route exact path="/about-us" component={AboutContainer} />
            <Route exact path="/blog" component={BlogContainer} />
            <Route exact path="/blog/:id" component={PostContainer} />
            <Route exact path="/contact" component={ContactContainer} />
            <Route exact path="/our-tools" component={OurToolContainer} />
            <Route exact path="/methodology" component={MethodologyContainer} />
            <Route exact path="/services" component={ServicesContainer} />
            <Route exact path="/contact" component={Contact} />
            <Route exact path="/360/survey" component={EvaluationContainer} />
            <Route
              exact
              path="/360/survey/:id"
              component={EvaluationContainer}
            />

            {/* ROUTES FOR TA */}
            <TARoute
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isTest={this.props.isAdmin}
              isTestLoaded={this.props.isAdminLoaded}
              exact
              path="/twentyfivesections/survey"
              component={EvaluationContainer}
            />
            <Route
              exact
              path="/twentyfivesections/survey/:id"
              component={EvaluationContainer}
            />

            <Route
              exact
              path="/twentyfivesections/survey/:id/results"
              component={SurveyResultsHOCContainer}
            />

            <TARoute
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isTest={this.props.isAdmin}
              isTestLoaded={this.props.isAdminLoaded}
              exact
              path="/profile/survey"
              component={EvaluationContainer}
            />
            <Route
              exact
              path="/profile/survey/:id"
              component={EvaluationContainer}
            />
            <Route
              exact
              path="/profile/survey/:id/results"
              component={SurveyResultsHOCContainer}
            />
            <TARoute
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isTest={this.props.isAdmin}
              isTestLoaded={this.props.isAdminLoaded}
              exact
              path="/twelvesections/survey"
              component={EvaluationContainer}
            />

            <Route
              exact
              path="/twelvesections/survey/:id"
              component={EvaluationContainer}
            />

            <Route
              exact
              path="/twelvesections/survey/:id/results"
              component={SurveyResultsHOCContainer}
            />
            {/*  */}

            <Route
              exact
              path="/360/survey/:id/results"
              component={SurveyResultsHOCContainer}
            />

            <Route
              exact
              path="/ta/survey/:id"
              component={EvaluationContainer}
            />
            <Route exact path="/sign-in" component={Signin} />

            <Route
              exact
              path="/front-page/:id"
              component={FrontPageContainer}
            />

            <Route exact path="/reset-password" component={ForgotPassword} />

            <PrivateRoute
              exact
              path="/admin/blog"
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isAdmin={this.props.isAdmin}
              isAdminLoaded={this.props.isAdminLoaded}
              component={BlogCollectionContainer}
            />
            <PrivateRoute
              exact
              path="/admin/blog/:id"
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isAdmin={this.props.isAdmin}
              isAdminLoaded={this.props.isAdminLoaded}
              component={BlogDocumentContainer}
            />
            <PrivateRoute
              exact
              path="/admin/results"
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isAdmin={this.props.isAdmin}
              isAdminLoaded={this.props.isAdminLoaded}
              component={ResultCollectionContainer}
            />

            <PrivateRoute
              exact
              path="/admin/twelvesections"
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isAdmin={this.props.isAdmin}
              isAdminLoaded={this.props.isAdminLoaded}
              component={ResultCollectionContainer}
            />

            <PrivateRoute
              exact
              path="/admin/twentyfivesections"
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isAdmin={this.props.isAdmin}
              isAdminLoaded={this.props.isAdminLoaded}
              component={ResultCollectionContainer}
            />

            <PrivateRoute
              exact
              path="/admin/profile"
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isAdmin={this.props.isAdmin}
              isAdminLoaded={this.props.isAdminLoaded}
              component={ResultCollectionContainer}
            />

            <PrivateRoute
              exact
              path="/admin/users"
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isAdmin={this.props.isAdmin}
              isAdminLoaded={this.props.isAdminLoaded}
              component={UserCollectionContainer}
            />

            <PrivateRoute
              exact
              path="/admin/profile/:id"
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isAdmin={this.props.isAdmin}
              isAdminLoaded={this.props.isAdminLoaded}
              component={ResultTaDocumentContainer}
            />

            <PrivateRoute
              exact
              path="/admin/360/:id"
              userRole={this.props.userRole}
              uid={this.props.userUID}
              getUser={this.props.getUser}
              isAdmin={this.props.isAdmin}
              isAdminLoaded={this.props.isAdminLoaded}
              component={ResultDocumentContainer}
            />
          </Switch>
        </div>
      </Router>
    );
  }
}

const mapActionToProps = {
  changeLanguage,
  getUserData,
  signInSuccess,
  signedOut,
  getUser
};

function mapStateToProps(state) {
  return {
    isAdmin: state.user.isAdmin,
    isAdminLoaded: state.user.isAdminLoaded,
    userUID: state.user.user && state.user.user.uid,
    userRole: state.user && state.user.role
  };
}

export default connect(
  mapStateToProps,
  mapActionToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js